// extracted by mini-css-extract-plugin
export default {"container":"period-controls_container__gRWRt","label":"period-controls_label__yPadR"};